// import { QRCodeVerification, VerifyOtp } from "../screens";

export const mixpanelConstants = {};

export const mixpanelEvents = {
  SIGNUP: {
    LABEL: 'signup',
    SIGNIN_METHOD: 'signin_method',
    APPLE: 'Apple',
    GOOGLE: 'Google',
    PHONE: 'Phone',
    EMAIL: 'Email',
  },
  LOGIN: {
    LABEL: 'login',
    LOGIN_METHOD: 'login_method',
    APPLE: 'Apple',
    GOOGLE: 'Google',
    PHONE: 'Phone',
    EMAIL: 'Email',
  },
};

export const mixPanelEventsConstants = {
  ADD_SERVICES: 'add_services',
  DASHBOARD: 'dashboard',
  TRANSACTION_COMPLETION_SUCCESS: 'transaction_completion_success',
  VIEW_BOOKINGS_DETAILS_INPUT_CODE: 'view_bookings_details_input_code',
  VIEW_BOOKINGS_DETAILS_SCAN_QR: 'view_bookings_details_scan_QR',
  VIEW_BOOKINGS: 'view_bookings',
  VIEW_BOOKINGS_DETAILS: 'view_booking_details',
  ADD_DEAL: 'add_deal',
  VIEW_DEAL: 'view_deal',
  VIEW_DEAL_TYPE: 'view_deal_type',
  VIEW_DEAL_TYPE_INPUT_CODE: 'view_deal_type_input_code',
  VIEW_DEAL_TYPE_SCAN_QR: 'view_deal_type_scan_QR',
  VIEW_DEAL_TYPE_VIEW_DETAILS: 'view_deal_type_view_details',
  USER_ONBOARDING: 'user_onboarding',
  ADD_PRODUCT: 'add_product',
  VIEW_MAIN_DASHBOARD: 'view_main_dashboard',
  VIEW_REVENUE: 'view_revenue',
  CLICK_BANNER: 'click_banner',
  ACCESS_USER_PROFILE: 'access_user_profile',
  ACCESS_WALLET: 'access_wallet',
  VIEW_NOTIFICATIONS: 'view_notifications',
  USER_FIRST_LOGIN: 'user_first_login',
  VIEW_MORE: 'view_more',
  VIEW_MERCHANT_PROFILE: 'view_merchant_profile',
  BUSINESS_OBJECTIVE: 'business_objective',
  VIEW_PRODUCTS: 'view_products',
  MERCHANT_PROFILE_COMPLETE: 'merchant_profile_complete',
  MERCHANT_PROFILE_BUSINESS: 'merchant_profile_business',
  MERCHANT_PROFILE_PERSONAL: 'merchant_profile_personal',
  MERCHANT_PROFILE_SETUP: 'merchant_profile_setup',
  COMPLETE_TRANSACTION_QR: 'complete_transaction_QR',
  COMPLETE_TRANSACTION_CODE: 'complete_transaction_Code',
  CREATE_BUZZ: 'create_buzz',
  SEND_BUZZ: 'send_buzz',
  USER_SIGNED_UP: 'user_signed_up',
  OTP_VERIFIED: 'otp_verified',
  ONBOARDING: 'onboarding',
  USER_SIGNED_IN: 'user_signed_in',
  GUEST_SIGN_IN: 'guest_sign_in',
  GO_HOME: 'go_home',
  VIEW_DEALS: 'view_deals',
  VIEW_ORDERS: 'view_orders',
  GLOBAL_SEARCH: 'global_search',
  VIEW_BOOK_APPOINTMENT: 'view_book_appointment',
  VIEW_SERVICES: 'view_services',
  VIEW_SERVICES_ALL: 'view_services_all',
  VIEW_SERVICES_CATEGORIES: 'view_services_categories',
  VIEW_SERVICES_MERCHANTS: 'view_services_merchants',
  BOOK_SERVICE: 'book_service',
  VIEW_SELECT_CATEGORY_ITEMS: 'view_select_category_items',
  VIEW_MERCHANT_PROFILE_ABOUT: 'view_merchant_profile_about',
  VIEW_MERCHANT_PROFILE_SERVICES: 'view_merchant_profile_services',
  VIEW_MERCHANT_PROFILE_DEALS: 'view_merchant_profile_deals',
  VIEW_MERCHANT_PROFILE_PRODUCTS: 'view_merchant_profile_products',
  SELECT_STAFF: 'select_staff',
  SEND_MERCHANT_CHAT: 'send_merchant_chat',
  VIEW_DEALS_ALL: 'view_deals_all',
  VIEW_DEALS_CATEGORIES: 'view_deals_categories',
  VIEW_DEAL_MERCHANTS: 'view_deal_merchants',
  OPEN_DEAL: 'open_deal',
  VIEW_ORDERS_LIST: 'view_orders_list',
  VIEW_PRODUCT_ORDERS_INFO: 'view_product_orders_info',
  VIEW_BOOKING_ORDERS_INFO: 'view_booking_orders_info',
  VIEW_BOOKINGS_DETAILS: 'view_bookings_details',
  VIEW_BOOKINGS_CALENDAR_TIMEFRAME: 'view_bookings_calendar_timeframe',
  VIEW_BOOKINGS_CALENDAR: 'view_bookings_calendar',
  NAV_BAR: 'nav_bar',
  SERVICES: 'services',
  PRODUCTS: 'products',
  DEALS: 'deals',
  BOOKINGS: 'bookings',
  ORDERS: 'orders',
  RATING_AND_REVIEW: 'ratings_n_review',
  MERCHANT_PROFILE: 'merchant_profile',
  MORE: 'more'
}

export const mixPanelEventsScreens = {
  SENDBUZZ: 'SendBuzz',
  QRCODEVERIFICATION: 'QRCodeVerification',
  PROFILESETUPTAB: 'ProfileSetupTab',
  PERSONALTAB: 'PersonalTab',
  BUSINESSTAB: 'BusinessTab',
  DEAL: 'Deal',
  PRODUCTS: 'Products',
  ORDERTRACKING: 'OrderTracking',
  CUSTOMISEPROFILE: 'CustomiseProfile',
  MORESCREENS: 'MoreActionPage',
  LOGIN: 'Login',
  LISTING: 'Listing',
  SERVICES: 'Services',
  BOOKINGDETAIL: 'BookingDetail',
  TODAYTIMELINE: 'TodayTimeline',
  WEEKTIMELINE: 'WeekTimeline',
  DEALS: 'Deals',
  EDITDEALS: 'EditDeals',
  TODAY_HOT_DEALS: 'TodayHotDeals',
  REQUEST_LOCATION: 'RequestLocation',
  REQUEST_MANUAL_LOCATION: 'RequestManuallLocation',
  ORDERS: 'Orders',
  MORE: 'More',
  PRODUCT_TAB: 'ProductTab',
  MERCHANT_PROFILE: 'ViewBusinessPage',
  FIND_DEAL: 'FindDeal',
  BOOKING_DETAILS: 'BookingDetails',
  VIEW_LISTING: 'ViewListing',
  DEALS_PAGE: 'DealsPage',


  //////
  SIGNUP: 'AuthenticationPage',
  VERIFYOTP: 'MerchantDetails',
  PROFILEBASICINFO: 'ProfileBasicInfo',
  MERCHANT_ONBOARDING: 'MerchantOnboarding',
  HOME: 'Home',
  PAYOUT_DETAILS_PAGE: 'PayoutDetailsPage',
  EDIT_LISTING: 'EditListingPage',
  LISTING_PAGE: 'ListingPage',
  NAV_BAR: 'NavBar',
  INTEREST_SELECTION: 'InterestSelection',
  CUSTOMER_DETAILS: 'CustomerDetails',
  ALOGLIA_SEARCH_PAGE: 'AlgoliaSearchPage',
  ORDER_COMPLETE_PAGE: 'OrderCompletePage',
  INBOX_PAGE: 'InboxPage',
  TRANSACTION_PAGE: 'TransactionPage',
  BOOKINGS: 'CalendarPage',
  VALIDATION_PAGE: 'ValidationPage',
}

// property/action types
export const mixPanelEventsData = {
  UPDATE_BUZZ_DETAILS: 'update_buzz_details',
  SEND_BUZZ_SUCCESS: 'send_buzz_success',
  OTHER_BIZ_INFO: 'other_biz_info',
  FIRST_DEAL_SUCCESS: 'first_deal_success',
  CREATE_PRODUCT: 'create_product',
  CREATE_SERVICES_SUCCESS: 'create_services_success',
  CREATE_PRODUCT_SUCCESS: 'create_product_success',
  VIEW_ONBOARDING_DASHBOARD: 'view_onboarding_dashboard',
  CREATE_SERVICES: 'create_services',
  CREATE_DEAL_SUCCESS: 'create_deal_success',
  INITIATE_CREATE_DEAL: 'initiate_create_deal',
  CREATE_FIRST_DEAL: 'create_first_deal',
  CREATE_DEAL_ADD_DETAILS: 'create_deal_add_details',
  SELECT_DEAL_TYPE: 'select_deal_type',
  ADD_ITEM: 'add_item',
  CREATE_SERVICES_ADD_ITEM: 'create_services_add_item',
  CREATE_PRODUCT_ADD_ITEMS: 'create_product_add_items',
  VIEW_MORE_DEALS: 'view_more_deals',
  SWIPE_LEFT: 'swipe_left',
  SWIPE_RIGHT: 'swipe_right',
  SIGN_UP: 'sign_up',
  ADD_LOCATION: 'add_location',
  SELECT_INTERESTS: 'select_interests',
  VIEW_WELCOME_MODAL: 'view_welcome_modal',
  CLICK_WELCOME_BANNER: 'click_welcome_banner',
  VIEW_SERVICE: 'view_service',
  SELECT_TIMESLOT: 'select_timeslot',
  ADD_TO_CART: 'add_to_cart',
  REMOVE_FROM_CART: 'remove_from_cart',
  SELECT_PRODUCT: 'select_product',
  REMOVE_PRODUCT_FROM_CART: 'remove_product_from_cart',
  ADD_PRODUCT_TO_CART: 'add_product_to_cart',
  ADD_SERVICE_TO_CART: 'add_service_to_cart',
  TIMEFRAME: 'timeframe',
  REDEEM_DEAL_NOW: 'redeem_deal_now',
  TRANSACTION_COMPLETION_SUCCESS: 'transaction_completion_status',
  BOOKINGS_VALIDATED_QR: 'bookings_validated_QR',
  BOOKINGS_VALIDATED_ACCESS_CODE: 'bookings_validated_access_code',
  COMPLETE_REVIEW: 'complete_review',
  RATE_MERCHANT: 'rate_merchant',
  SHARE_BOOKING_LINK: 'share_booking_link',
  RATE_CUSTOMER: 'rate_customer',
  ADD_ITEM_TYPE_SERVICE: 'add_item_type_service',
  ADD_ITEM_TYPE_PRODUCT: 'add_item_type_product',


  // merchant_signin event's property names
  MERCHANT_LOGGED_IN: "merchant_loggedin",
  VIEW_DASHBOARD: "view_dashboard",

  // customer_loggedin event's property names
  CUSTOMER_LOGGED_IN: "customer_signedIn",

  // merchant_signup_complete event's property names
  SIGNUP_COMPLETED: "signup_completed",
  OTP_VERIFIED: "otp_verified",
  BUSINESS_GOAL: "business_goal",
  SIGNUP_DASHBOARD: "signup_dashboard", //~
  CREATE_SERVICE: "create_service", //- also for merchant_service_created event
  CREATE_PRODUCT: "create_product", //- also for merchant_product_created event 
  CREATE_DEAL: "create_deal", //- also for merchant_deal_created event
  SET_BUSINESS_INFO: "set_business_info",
  PUBLISH_LISTING: "publish_listing",

  // customer_signup_complete event's property names
  CUSTOMER_OTP_VERIFIED: "customer_otp_verified",
  CUSTOMER_SIGNUP_COMPLETED: "customer_signup_completed",
  CUSTOMER_SETUP_LANGUAGE: "customer_setup_language",
  CUSTOMER_SETUP_LOCATION: "customer_setup_location", //#
  CUSTOMER_SETUP_INTERESTS: "customer_setup_interests",

  // merchant_payout_completed event's property names
  ADD_PAYOUT_DETAILS: "add_payout_details",
  PAYOUT_COMPLETED: "payout_completed",

  // customer_search event's property names
  CUSTOMER_SEARCH: "customer_search",

  // customer_booking event's property names
  CUSTOMER_BOOKING: "customer_booking",

  // customer_redeem_deal event's property names
  DEAL_PURCHASED: "deal_purchased",
  DEAL_VIEWED: "deal_viewed",

  // customer_bookings_calendar event's property names
  CUSTOMER_VIEW_CALENDAR: "customer_view_calendar",
  CUSTOMER_VIEW_DETAILS: "customer_view_details",

  // customer_booking_completed event's property names
  CUSTOMER_SHOW_BOOKING_QR: "customer_show_booking_qr",
  CUSTOMER_BOOKING_RESCHEDULE: "customer_booking_reschedule",
  CUSTOMER_BOOKING_CANCEL: "customer_booking_cancel",

  // merchant_booking_received event's property names
  VIEW_BOOKINGS_CALENDAR: "view_bookings_calendar",

  // merchant_booking_completed event's property names
  BOOKINGS_QR: "bookings_qr",
  BOOKINGS_CODE: "bookings_code",
  BOOKING_COMPLETED: "booking_completed",
}

// SendGrid template IDs
export const SENDGRID_TEMPLATE_IDS = {
  PAYOUT_CREATED_MERCHANT: "d-4e16dbbf7e244fe09baa1cf307d980dd",
}

export const Events = {
  USER_SIGN_IN: 'user_sign_in',
  OTP_VERIFICATION: 'otp_verification',
  USER_REGISTRATION_COMPLETE: 'user_registration_complete',
  PRODUCT_VIEW: 'product_view',
  SERVICE_VIEW: 'service_view',
  ADD_TO_CART: 'add_to_cart',
  CHECKOUT_INITIATE: 'checkout_initiate',
  APPOINTMENT_SCHEDULE: 'appointment_schedule',
  PURCHASE_COMPLETE: 'purchase_complete',
  SETUP_BUSINESS_PROFILE: 'setup_business_profile',
  LIST_PRODUCT: 'list_product',
  LIST_SERVICE: 'list_service',
  CREATE_DEAL: 'create_deal',

  // SIGN IN EVENTS
  MERCHANT_SIGN_IN: "merchant_signin",
  CUSTOMER_SIGN_IN: "customer_loggedin",

  // SIGN UP EVENTS
  MERCHANT_SIGNUP_COMPLETE: "merchant_signup_complete",
  CUSTOMER_SIGNUP_COMPLETE: "customer_signup_complete",

  // Merchant Completes Payout Events
  MERCHANT_PAYOUT_COMPLETED: "merchant_payout_completed",

  // Service Created by Merchant Events
  MERCHANT_SERVICE_CREATED: "merchant_service_created",

  // Product Created by Merchant Events
  MERCHANT_PRODUCT_CREATED: "merchant_product_created",

  // Deal Created by Merchant Events
  MERCHANT_DEAL_CREATED: "merchant_deal_created",

  // Customer Searches for Item Events
  CUSTOMER_SEARCH: "customer_search",

  // Customer Books A Service Events
  CUSTOMER_BOOKING: "customer_booking",

  // Customer Books A Deal Events
  CUSTOMER_REDEEM_DEAL: "customer_redeem_deal",

  // Customer Views Calendar Events
  CUSTOMER_BOOKINGS_CALENDAR: "customer_bookings_calendar",

  // Booking Completed by Customer Events
  CUSTOMER_BOOKING_COMPLETED: "customer_booking_completed",

  // Booking Received by Merchant
  MERCHANT_BOOKING_RECEIVED: "merchant_booking_received",

  // Booking Completed by Merchant
  MERCHANT_BOOKING_COMPLETED: "merchant_booking_completed",

  // Merchant redeems a booking and the funds become theirs
  MERCHANT_FUNDS_RELEASED: "merchant_funds_released",

  // Customer raises a dispute
  DISPUTE_RAISED: "dispute_raised",

  // Merchant resolves a dispute (accept or decline)
  DISPUTE_RESOLVED: "dispute_resolved",

  // Customer cancels a booking
  TRANSACTION_CANCELLED: "transaction_cancelled",
};

export const EVENT_MAPPING = {
  //  new events
  [Events.MERCHANT_SIGNUP_COMPLETE]: {
    firebase: 'merchant_signup_complete',
    meta: 'merchant_signup_complete',
    mixpanel: 'merchant_signup_complete',
  },

  [Events.CUSTOMER_SIGNUP_COMPLETE]: {
    firebase: 'customer_signup_complete',
    meta: 'customer_signup_complete',
    mixpanel: 'customer_signup_complete',
  },

  [Events.MERCHANT_SIGN_IN]: {
    firebase: 'merchant_signin',
    meta: 'merchant_signin',
    mixpanel: 'merchant_signin',
  },

  [Events.CUSTOMER_SIGN_IN]: {
    firebase: 'customer_loggedin',
    meta: 'customer_loggedin',
    mixpanel: 'customer_loggedin',
  },

  [Events.MERCHANT_PAYOUT_COMPLETED]: {
    firebase: 'merchant_payout_completed',
    meta: 'merchant_payout_completed',
    mixpanel: 'merchant_payout_completed',
  },

  [Events.MERCHANT_SERVICE_CREATED]: {
    firebase: 'merchant_service_created',
    meta: 'merchant_service_created',
    mixpanel: 'merchant_service_created',
  },

  [Events.MERCHANT_PRODUCT_CREATED]: {
    firebase: 'merchant_product_created',
    meta: 'merchant_product_created',
    mixpanel: 'merchant_product_created',
  },

  [Events.MERCHANT_DEAL_CREATED]: {
    firebase: 'merchant_deal_created',
    meta: 'merchant_deal_created',
    mixpanel: 'merchant_deal_created',
  },

  [Events.CUSTOMER_SEARCH]: {
    firebase: 'customer_search',
    meta: 'customer_search',
    mixpanel: 'customer_search',
  },

  [Events.CUSTOMER_BOOKING]: {
    firebase: 'customer_booking',
    meta: 'customer_booking',
    mixpanel: 'customer_booking',
  },

  [Events.CUSTOMER_REDEEM_DEAL]: {
    firebase: 'customer_redeem_deal',
    meta: 'customer_redeem_deal',
    mixpanel: 'customer_redeem_deal',
  },

  [Events.CUSTOMER_BOOKINGS_CALENDAR]: {
    firebase: 'customer_bookings_calendar',
    meta: 'customer_bookings_calendar',
    mixpanel: 'customer_bookings_calendar',
  },

  [Events.CUSTOMER_BOOKING_COMPLETED]: {
    firebase: 'customer_booking_completed',
    meta: 'customer_booking_completed',
    mixpanel: 'customer_booking_completed',
  },

  [Events.MERCHANT_BOOKING_RECEIVED]: {
    firebase: 'merchant_booking_received',
    meta: 'merchant_booking_received',
    mixpanel: 'merchant_booking_received',
  },

  [Events.MERCHANT_BOOKING_COMPLETED]: {
    firebase: 'merchant_booking_completed',
    meta: 'merchant_booking_completed',
    mixpanel: 'merchant_booking_completed',
  },

  [Events.MERCHANT_FUNDS_RELEASED]: {
    firebase: 'merchant_funds_released',
    meta: 'merchant_funds_released',
    mixpanel: 'merchant_funds_released',
  },

  [Events.DISPUTE_RAISED]: {
    firebase: 'dispute_raised',
    meta: 'dispute_raised',
    mixpanel: 'dispute_raised',
  },

  [Events.DISPUTE_RESOLVED]: {
    firebase: 'dispute_resolved',
    meta: 'dispute_resolved',
    mixpanel: 'dispute_resolved',
  },

  [Events.TRANSACTION_CANCELLED]: {
    firebase: 'transaction_cancelled',
    meta: 'transaction_cancelled',
    mixpanel: 'transaction_cancelled',
  },
  /////

  // Customer App Events
  [Events.USER_SIGN_IN]: {
    firebase: 'login',
    meta: 'Login',
    mixpanel: 'User Sign In'
  },
  [Events.OTP_VERIFICATION]: {
    firebase: 'otp_verification_complete',
    meta: 'OTP_Verification_Complete',
    mixpanel: 'OTP Verification'
  },
  [Events.USER_REGISTRATION_COMPLETE]: {
    firebase: 'sign_up',
    meta: 'CompleteRegistration',
    mixpanel: 'Registration Complete'
  },
  [Events.PRODUCT_VIEW]: {
    firebase: 'view_item',
    meta: 'ViewContent',
    mixpanel: 'Product Viewed'
  },
  [Events.SERVICE_VIEW]: {
    firebase: 'view_service',
    meta: 'View_Service',
    mixpanel: 'Service Viewed'
  },
  [Events.ADD_TO_CART]: {
    firebase: 'add_to_cart',
    meta: 'AddToCart',
    mixpanel: 'Product Added to Cart'
  },
  [Events.CHECKOUT_INITIATE]: {
    firebase: 'begin_checkout',
    meta: 'InitiateCheckout',
    mixpanel: 'Checkout Started'
  },
  [Events.APPOINTMENT_SCHEDULE]: {
    firebase: 'schedule_appointment',
    meta: 'Schedule_Appointment',
    mixpanel: 'Appointment Scheduled'
  },
  [Events.PURCHASE_COMPLETE]: {
    firebase: 'purchase',
    meta: 'Purchase',
    mixpanel: 'Purchase Complete'
  },
  [Events.SETUP_BUSINESS_PROFILE]: {
    firebase: 'setup_business_profile',
    meta: 'CompleteRegistration',
    mixpanel: 'Business Profile Setup Complete'
  },
  // Business Action Events
  [Events.LIST_PRODUCT]: {
    firebase: 'list_product',
    meta: 'list_product',
    mixpanel: 'Product Listed'
  },
  [Events.CREATE_DEAL]: {
    firebase: 'create_deal',
    meta: 'create_deal',
    mixpanel: 'Deal Created'
  },
  [Events.LIST_SERVICE]: {
    firebase: 'list_service',
    meta: 'list_service',
    mixpanel: 'Service Listed'
  },
};
